import { render } from "./CustomersNewPage.vue?vue&type=template&id=50f0ff7d&ts=true"
import script from "./CustomersNewPage.vue?vue&type=script&lang=ts"
export * from "./CustomersNewPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__